import { createReducer } from "reduxsauce"
import createActions from "helpers/actionCreator"

export const { Types, Creators } = createActions("ompnt/modules/optimizationScorecard", {
  setDecompositionType: {
    props: ["decompositionType"],
    track: true,
    trackType: "scorecard-view-selection",
  },
})

const DEFAULT_STATE = {
  decompositionType: "risk",
}

function handleSetDecompositionType(state, { decompositionType }) {
  return { ...state, decompositionType }
}

export default createReducer(DEFAULT_STATE, {
  [Types.SET_DECOMPOSITION_TYPE]: handleSetDecompositionType,
})
